import { RpmLeaderboardEntry, TrainingLaunch, UserTrainingStats } from '../../domain/models/TrainingLaunch';

export interface TrainingLaunchEntity {
  id: string;
  user_id: string;
  timestamp: number;
  note?: string;
  rpm_max: number;
  rpm_avg: number;
  rpm_history: number[];
  last_angle_x: number;
  last_angle_y: number;
  energy: number;
  pulses: number;
  est_spin_time: number;
  consistency: number;
  launch_duration: number;
  launch_score: number;
  speed_kmh: number;
  created_at: string;
}

export interface RpmLeaderboardEntryEntity {
  user_id: string;
  display_name: string;
  avatar_url?: string;
  best_rpm: number;
  total_launches: number;
  avg_consistency: number;
  avg_score: number;
}

export interface UserTrainingStatsEntity {
  total_launches: number;
  best_rpm: number | null;
  avg_rpm: number | null;
  avg_consistency: number | null;
  avg_score: number | null;
  best_speed_kmh: number | null;
  last_launch_at: number | null;
}

export const trainingLaunchEntityToModel = (e: TrainingLaunchEntity): TrainingLaunch => ({
  id: e.id,
  userId: e.user_id,
  timestamp: e.timestamp,
  note: e.note,
  rpmMax: e.rpm_max,
  rpmAvg: e.rpm_avg,
  rpmHistory: e.rpm_history,
  lastAngleX: e.last_angle_x,
  lastAngleY: e.last_angle_y,
  energy: e.energy,
  pulses: e.pulses,
  estSpinTime: e.est_spin_time,
  consistency: e.consistency,
  launchDuration: e.launch_duration,
  launchScore: e.launch_score,
  speedKmh: e.speed_kmh,
  createdAt: new Date(e.created_at),
});

export const trainingLaunchModelToEntity = (m: TrainingLaunch): Omit<TrainingLaunchEntity, 'created_at'> => ({
  id: m.id,
  user_id: m.userId,
  timestamp: m.timestamp,
  note: m.note,
  rpm_max: m.rpmMax,
  rpm_avg: m.rpmAvg,
  rpm_history: m.rpmHistory,
  last_angle_x: m.lastAngleX,
  last_angle_y: m.lastAngleY,
  energy: m.energy,
  pulses: m.pulses,
  est_spin_time: m.estSpinTime,
  consistency: m.consistency,
  launch_duration: m.launchDuration,
  launch_score: m.launchScore,
  speed_kmh: m.speedKmh,
});

export const leaderboardEntryEntityToModel = (e: RpmLeaderboardEntryEntity): RpmLeaderboardEntry => ({
  userId: e.user_id,
  displayName: e.display_name,
  avatarUrl: e.avatar_url,
  bestRpm: Number(e.best_rpm ?? 0),
  totalLaunches: Number(e.total_launches ?? 0),
  avgConsistency: Number(e.avg_consistency ?? 0),
  avgScore: Number(e.avg_score ?? 0),
});

export const userTrainingStatsEntityToModel = (e: UserTrainingStatsEntity): UserTrainingStats => ({
  totalLaunches: Number(e.total_launches ?? 0),
  bestRpm: e.best_rpm ?? 0,
  avgRpm: e.avg_rpm ?? 0,
  avgConsistency: e.avg_consistency ?? 0,
  avgScore: e.avg_score ?? 0,
  bestSpeedKmh: e.best_speed_kmh ?? 0,
  lastLaunchAt: e.last_launch_at ?? null,
});
